import * as React from "react";

import { UitkFigure, UitkImage } from "uitk-react-images";
import { UitkHeading, UitkText } from "uitk-react-text";
import { UitkCard, UitkCardContentSection, UitkCardLink } from "uitk-react-cards";

import { MediaAttribution } from "components/utility/MediaAttributionUtil";
import { TrackedLink } from "components/utility/analytics/TrackedLink";

import { VisitorBlogCardProps } from "../typings";
import { BlossomImage } from "src/components/shared/BlossomImage/BlossomImage";
import LazyLoad from "react-lazyload";

const VisitorBlogCard = (props: VisitorBlogCardProps) => {
  const { visitorBlog, visitorBlogImageUrl } = props;
  const { name, description, media, link } = visitorBlog;

  const attribution = MediaAttribution(media, name);

  return (
    <UitkCard>
      <UitkFigure>
        <LazyLoad placeholder={<UitkImage alt={attribution.attributionAltText} placeholderImage />} offset={250} once>
          <BlossomImage src={visitorBlogImageUrl} alt={attribution.attributionAltText} />
        </LazyLoad>
        {attribution.attributionText}
      </UitkFigure>

      <UitkCardContentSection>
        <UitkHeading tag="h4" size={6}>
          {name}
        </UitkHeading>
        <UitkText size={300} spacing="two">
          {description}
        </UitkText>
      </UitkCardContentSection>

      <UitkCardLink>
        <TrackedLink moduleName="TG.LP" href={link} rfrr="Dest.Articles" linkName={name}>
          {name}
        </TrackedLink>
      </UitkCardLink>
    </UitkCard>
  );
};

export default VisitorBlogCard;
